import { create } from "zustand";
import useApi from "../helper/apiConfig";
import { apiRoutes } from "../helper/constant";

export const useNotificationStore = create((set) => ({
  notificationListData: null,
  notificationListLoading: false,
  notificationListError: false,
  notificationListSuccess: false,

  isPostNotificationData: null,
  isPostNotificationLoading: false,
  isPostNotificationError: false,
  isPostNotificationSuccess: false,

  isPutNotificationStatusLoading: true,
  isPutNotificationsStatusError: false,
  isPutNotificationStatusSuccess: false,
  putNotificationStatusData: null,

  setState: (data) => set((state) => ({ ...state, ...data })),
}))

export const useFetchNotificationList = () => {
  const apiV5 = useApi(process.env.REACT_APP_BASE_URL_V5);
  const { setState } = useNotificationStore();

  const fetchNotificationList = async (queryParams = {}) => {
    setState({
      notificationListLoading: true,
      notificationListError: false,
      notificationListSuccess: false,
    });

    try {
      const query = new URLSearchParams(queryParams).toString();
      const response = await apiV5.get(
        `${apiRoutes.notification.getNotificationList}/?${query}`,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
            instanceid: `${sessionStorage.getItem("instanceId")}`,
          },
        }
      );
      const { data: notificationData } = response;
      console.log(notificationData);
      setState({
        notificationListData: notificationData,
        notificationListSuccess: true,
      });
    } catch (error) {
      setState({ notificationListError: true });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ notificationListLoading: false });
    }
  };

  return fetchNotificationList;
};

export const usePostNotification = () => {
  const apiV5 = useApi(process.env.REACT_APP_BASE_URL_V5);
  const { setState } = useNotificationStore();

  const postNotification = async (data) => {
    setState({
      isPostNotificationLoading: true,
      isPostNotificationError: false,
    });

    try {
      const response = await apiV5.post(
        `${apiRoutes.notification.postNotification}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
            instanceid: `${sessionStorage.getItem("instanceId")}`,
          },
        }
      );
      const { data: notificationData } = response;
      setState({
        isPostNotificationData: notificationData,
        isPostNotificationSuccess: true,
      });
    } catch (error) {
      setState({
        isPostNotificationError: true,
        isPostNotificationData: error.response.data.status.message
      });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isPostNotificationLoading: false });
    }

  };

  return postNotification;
};

export const usePutNotificationStatus = () => {
  const apiV5 = useApi(process.env.REACT_APP_BASE_URL_V5);
  const { setState } = useNotificationStore();

  const putNotificationStatus = async (id,data) => {
    setState({
      isPutNotificationStatusLoading: true,
      isPutNotificationStatusError: false,
      isPutNotificationStatusSuccess: false,
    });

    try {
      const response = await apiV5.put(
        `${apiRoutes.notification.deactivateNotification}/${id}`,
        data,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("authToken")}`,
            instanceId: sessionStorage.getItem("instanceId"),
          },
        }
      );
      const { data: reOutcomesData } = response;
      setState({
        putNotificationStatusData: reOutcomesData,
        isPutNotificationStatusSuccess: true,
      });
    } catch (error) {
      setState({
        isPutNotificationStatusError: true,
      });
      console.error("Failed to fetch data:", error);
    } finally {
      setState({ isPutNotificationStatusLoading: false });
    }
  };

  return putNotificationStatus;
};